import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveUsersFromAssociationRoleAction} from '../action';

const tt = t('admin');

function* execute({payload: {roleId, associationId}}: RemoveUsersFromAssociationRoleAction): SagaIterator {
    const response = yield* call(Api.endUserProfileAssociationRoleBindingForRole, {roleId, associationId});

    if (response.isSuccess) {
        yield* put(adminAction.getManagementAssociationsTableData(opt({action: 'refresh'}), opt(associationId)));
        yield putAll(showSuccess(
            tt('removeUsersFromRole'),
            tt('removeUsersFromRoleSuccess'),
            false,
            'removeUsersFromRole',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeUsersFromRole')));
    }
}

/** Runs the admin saga that removes users from the selected association role. */
export function* removeUsersFromAssociationRole(): SagaIterator {
    yield takeLatestF('admin/REMOVE_USERS_FROM_ASSOCIATION_ROLE', execute);
}
